import { render, staticRenderFns } from "./ConfirmationApprovalMail.vue?vue&type=template&id=4d962804"
import script from "./ConfirmationApprovalMail.vue?vue&type=script&lang=js"
export * from "./ConfirmationApprovalMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports